import { cancel, createPromise, delay, delayAnimation, WaiterWith, } from "common/promises";
import log from "loglevel";
import * as R from "ramda";
import { AnnouncementSoundPlayer } from "./announcementPlayer";
import { ButtonInputFilter } from "./buttonInputFilter";
import { ZoomEffector } from "./zoomEffect";
export async function run(context) {
    const { aButton, bButton, cButton, backgroundPerson, backgroundPlayer, sound, person, background, container, pixiContext, backgroundpersonSoundPlayer, backgroundPersonAnimator, } = context;
    const announcementPlayer = new AnnouncementSoundPlayer(sound);
    const zoomEffector = new ZoomEffector(pixiContext, container);
    aButton.sprite.visible = true;
    bButton.sprite.visible = true;
    backgroundPersonAnimator.moveToTop();
    const destroyed = {
        value: false,
    };
    const lastWalkId = {
        value: 0,
    };
    person.listeners.add({
        async walk(time) {
            lastWalkId.value += 1;
            const myId = lastWalkId.value;
            background.sprite.play();
            await delayAnimation(time);
            if (destroyed.value === true) {
                return;
            }
            if (myId === lastWalkId.value) {
                background.sprite.stop();
            }
        },
    });
    cButton.play();
    console.log(backgroundPerson.leftSprite);
    const filter = new ButtonInputFilter(pixiContext, aButton, bButton);
    filter.clickedListeners.add({
        clicked() {
            person.walk();
        },
    });
    filter.waitingButtonListeners.add(cButton.onButtonListener);
    filter.waitingButtonListeners.add(announcementPlayer.onButtonListener);
    const applier = new StateChangeApplier(context);
    const buttonFromKeyboard = cancel.root(async (canceler) => {
        const buttons = repeat(aButton, bButton);
        while (true) {
            const keyUp = new WaiterWith();
            const onkeyup = (e) => {
                keyUp.trigger(e.key);
            };
            // need event clean up in mobile.
            $(document).one("keyup", onkeyup);
            const key = await keyUp.wait();
            canceler.check();
            if (key === " ") {
                const button = buttons.next().value;
                await button.onDown();
            }
            else if (key === "a") {
                for (let i = 0; i < 10; i += 1) {
                    canceler.check();
                    const button = buttons.next().value;
                    await button.onDown();
                    await delayAnimation(100);
                }
            }
        }
    });
    await Promise.all([
        backgroundPersonAnimator.followGoal(),
        filter.run((changedState) => {
            applier.onStateChange(changedState);
            log.info("change state", changedState);
            const speed = changedState.to.speed || 0;
            const clickCount = changedState.to.clickCount || 0;
            if (changedState.to.id == "finish") {
                backgroundPersonAnimator.state.id = "finish";
                backgroundpersonSoundPlayer.dispose();
                person.finish();
                announcementPlayer.playFinish();
                announcementPlayer.dispose();
            }
            else {
                zoomEffector.setSpeed(speed);
                backgroundPersonAnimator.setState(speed, clickCount);
                backgroundPlayer.setSpeed(speed);
                announcementPlayer.setSpeed(speed);
                backgroundpersonSoundPlayer.setSpeed(speed);
                cButton.speed = speed;
                person.speed = speed;
            }
        }),
    ]);
    // await delayAnimation(3000);
    person.stop();
    destroyed.value = true;
    buttonFromKeyboard.canceler.cancel();
    cButton.dispose();
    backgroundPlayer.dispose();
    // we couldn't make cancel properly.
    // await buttonFromKeyboard.promise;
    await delay(10);
    // await applier.waitLastSoundEffect();
    console.log("walk interaction finished");
}
class StateChangeApplier {
    constructor({ person, backgroundPerson, background, sound }) {
        this.finished = false;
        this.onStateChange = this.onStateChange.bind(this);
        this.person = person;
        this.backgroundPerson = backgroundPerson;
        this.background = background;
        this.sound = sound;
    }
    async waitLastSoundEffect() {
        const { promise, resolve } = await createPromise();
        this.onFinish = resolve;
        if (this.finished) {
            return;
        }
        await promise;
    }
    async onStateChange({ from, to }) {
        // if (to.id === "idle") {
        //   this.person.stop();
        //   this.background.sprite.stop();
        // } else {
        //   // this.person.play();
        //   this.background.sprite.play();
        // }
        if (to.id === "back" || to.id === "run") {
            this.background.sprite.animationSpeed = 0.1 * to.speed;
            if (to.speed >= 3 && to.speed <= 5) {
            }
            else {
            }
        }
        if (R.includes(from.id, ["run", "back"]) && to.id === "idle") {
            // this.sound.stopLoop("personWalk");
        }
        if (to.id === "finish") {
            // await this.sound.awaitPlay("cough");
            // await this.sound.awaitPlay("announcement2");
            // await this.sound.awaitPlay("background3");
            // await this.sound.awaitPlay("background3");
            // await this.sound.awaitPlay("background3");
            this.finished = true;
            if (this.onFinish) {
                this.onFinish();
            }
        }
    }
}
// Background person's position is determined by player speed.
function* repeat(a, b) {
    while (true) {
        yield a;
        yield b;
    }
}
//# sourceMappingURL=walkInteraction.js.map